/**
 * エラーをコンソールに出すときの整形。
 *
 * AxiosError をそのまま出すと `config.headers.Authorization`（Firebase の Bearer トークン）や
 * レスポンス本文（メールアドレスなどの個人情報）がブラウザのコンソール・Sentry の breadcrumb に残る。
 * Firebase のエラーも `message` にメールアドレスなどが入ることがある。
 * 出してよいのは「エラーの種類（name）・コード（code）・HTTP ステータス」だけ。
 * いずれも安全な識別子の形（英数字と `_ . / : -` のみ）のものに限り、自由文は出さない。
 */
export interface SafeErrorInfo {
  name?: string
  code?: string
  status?: number
}

const SAFE_IDENTIFIER = /^[A-Za-z0-9_./:-]{1,100}$/

const safeString = (value: unknown): string | undefined =>
  typeof value === 'string' && SAFE_IDENTIFIER.test(value) ? value : undefined

export function safeErrorInfo(error: unknown): SafeErrorInfo {
  if (typeof error !== 'object' || error === null) return {}
  const e = error as {
    name?: unknown
    code?: unknown
    status?: unknown
    response?: { status?: unknown }
  }
  const info: SafeErrorInfo = {}
  const name = safeString(e.name)
  if (name) info.name = name
  const code = safeString(e.code)
  if (code) info.code = code
  const status = [e.response?.status, e.status].find(
    (s): s is number => typeof s === 'number' && Number.isInteger(s)
  )
  if (status !== undefined) info.status = status
  return info
}
